"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabRendererCms = void 0;
var TabRendererCms = /** @class */ (function () {
    function TabRendererCms() {
        this.keepMyNumberLabel = 'Keep my number';
        this.newNumberLabel = 'Get a new number';
    }
    return TabRendererCms;
}());
exports.TabRendererCms = TabRendererCms;
//# sourceMappingURL=TabRenderer.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeviceOptionsPanel/DeviceCard/FormOptions/TabRenderer/TabRenderer.cms.js
// module id = 2006
// module chunks = 8